import Svg from 'components/utilities/svg'
import { FC, ReactElement } from 'react'

interface Props {
  className?: string
  fill?: string
  path?: string
}

const AnimatedLogo: FC<Props> = ({
  className,
  fill = 'text-gray',
  path = 'text-white',
}): ReactElement => (
  <Svg className={className} viewBox="0 0 250 250">
    <path
      d="m190 0c16.568542 0 30 13.4314575 30 30v160c0 16.568542-13.431458 30-30 30h-160c-16.5685425 0-30-13.431458-30-30v-160c0-16.5685425 13.4314575-30 30-30z"
      className={`fill-current ${fill}`}
    />
    <g className={`fill-current ${path} animate-logo-corners`}>
      <path d="m40 176c0 2.209139 1.790861 4 4 4-2.209139 0-4 1.790861-4 4 0-2.209139-1.790861-4-4-4 2.209139 0 4-1.790861 4-4z" />
      <path d="m180 176c0 2.209139 1.790861 4 4 4-2.209139 0-4 1.790861-4 4 0-2.209139-1.790861-4-4-4 2.209139 0 4-1.790861 4-4z" />
      <path d="m40 36c0 2.209139 1.790861 4 4 4-2.209139 0-4 1.790861-4 4 0-2.209139-1.790861-4-4-4 2.209139 0 4-1.790861 4-4z" />
      <path d="m180 36c0 2.209139 1.790861 4 4 4-2.209139 0-4 1.790861-4 4 0-2.209139-1.790861-4-4-4 2.209139 0 4-1.790861 4-4z" />
    </g>
    <g className={`fill-current ${path}`}>
      <path d="m110 60c5.522847 0 10 4.4771525 10 10v80c0 5.522847-4.477153 10-10 10s-10-4.477153-10-10v-80c0-5.5228475 4.477153-10 10-10z" />
      <path d="m70 100c5.5228475 0 10 4.477153 10 10v40c0 5.522847-4.4771525 10-10 10s-10-4.477153-10-10v-40c0-5.522847 4.4771525-10 10-10z" />
      <path d="m150 60c5.522847 0 10 4.4771525 10 10v40c0 5.522847-4.477153 10-10 10s-10-4.477153-10-10v-40c0-5.5228475 4.477153-10 10-10z" />
    </g>
    <g
      className={path.replace('text-', 'stroke-')}
      strokeLinecap="round"
      strokeWidth="20">
      <path className="animate-logo-path" d="m30 30h160" />
      <path className="animate-logo-reverse-path" d="m30 190h160" />
      <path
        className="animate-logo-path"
        d="m110 110h160"
        transform="matrix(0 1 -1 0 300 -80)"
      />
      <path
        className="animate-logo-reverse-path"
        d="m-50 110h160"
        transform="matrix(0 1 -1 0 140 80)"
      />
    </g>
  </Svg>
)

export default AnimatedLogo
